<div class="container" aria-modal="true">
    <div mat-dialog-title class="dialog-title">
        <h1 mat-dialog-title class="delete-title">Delete Treatment</h1>
        <button mat-icon-button aria-label="close dialog" mat-dialog-close class="delete-close">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <mat-dialog-content>
        <div class="title_light">
            This treatment is from GIS, and will be re-added on the next GIS update. Please confirm deletion.
        </div>
    </mat-dialog-content>
    <div mat-dialog-actions>
        <div class="button-row-always">
            <button class="usa-button usa-button--secondary" mat-dialog-close>Cancel</button>
            <button class="usa-button delete" (click)="deleteTreatment()">
                <i class="material-icons">delete</i>
                Delete</button>
        </div>
    </div>
</div>